import { useEffect } from 'react';

/**
 * Freezes the page behind an overlay.
 *
 * Without this, scrolling a menu or dialog on a phone scrolls the page
 * underneath it — which is what "the menu scrolls the content" looks like.
 * The scrollbar's width is compensated so the layout does not jump on
 * desktop when it disappears.
 */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;

    const { body, documentElement } = document;
    const previousOverflow = body.style.overflow;
    const previousPaddingRight = body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;

    body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      const current = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
      body.style.paddingRight = `${current + scrollbarWidth}px`;
    }

    return () => {
      body.style.overflow = previousOverflow;
      body.style.paddingRight = previousPaddingRight;
    };
  }, [locked]);
}
